// mockEnv должен быть импортирован первым для настройки окружения
import './mockEnv'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import { Root } from './components/Root'
import { init } from './init'
import '@twa-dev/sdk'
import './index.css'
import { ThemeProvider } from '@/components/theme-provider'

try {
  const launchParams = retrieveLaunchParams()
  init(launchParams?.startParam === 'debug' || import.meta.env.DEV)
} catch (e) {
  console.error(e)
  // Если не удалось получить launch params, инициализируем с дефолтными значениями
  init(import.meta.env.DEV)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <Root />
    </ThemeProvider>
  </StrictMode>
)
